<template lang="">
  <v-app>
    <v-container fluid>
      <v-row class="text-center mb-4">
        <v-col>
          <dialog-datos-historico v-if="datosTabla.length > 0" tipo_boton="otro" :cabecera="datosTabla[datosTabla.length - 1]"></dialog-datos-historico>
        </v-col>
      </v-row>
      <v-card>

      <!--FILTRO-->
        <div class="mb-4 mt-2 pl-3 pr-3">
          <v-row class="justify-center"> 
          <!-- FECHA INICIO -->
            <v-col
            cols="12"
            md="3"
            >
              <v-menu v-model="fechaInicioInput" :close-on-content-click="false" 
              :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                  v-model="fecha_inicio"
                  label="Fecha Inicio"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fecha_inicio" @input="fechaInicioInput = false"></v-date-picker>
              </v-menu>
            </v-col> 
            <!-- FECHA FIN -->
            <v-col
            cols="12"
            md="3"
            >
              <v-menu v-model="fechaFinInput" :close-on-content-click="false" 
              :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="fecha_fin"
                    label="Fecha Fin"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fecha_fin" @input="fechaFinInput = false"></v-date-picker>
              </v-menu>
            </v-col>
            <!-- TIPO DE TRATAMIENTO -->
            <v-col cols="12" md="2" class="custom-col">
              <v-select :items="tratamientos" item-text="name" item-value="id" label="Tipo de Tratamiento"
              v-model="tipo_tratamiento">
              </v-select>
            </v-col>
            <!-- TRABAJADOR -->
            <v-col cols="12" md="2" class="custom-col">
              <v-select :items="trabajadores" item-text="username" item-value="id" label="Trabajador"
              v-model="worker" >
              </v-select>
            </v-col>
          </v-row> 
          <!-- BOTON DE BUSCAR -->
          <v-row> 
            <v-col cols="12" class="text-center"> 
              <v-btn @click="getDatosHistorico"
              block
              color="primary">
                <v-icon>BUSCAR</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
        <!--TABLA-->
        <v-data-table
        :loading="loading"
        itemKey="id"
        :headers="headers"
        :items="datosTabla"
        :footer-props="{
        'items-per-page-options': [5, 10, 20, 30,40, 50],
        'items-per-page-text': 'Tratamientos por página'
        }"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        >

          <template v-slot:[`item.numero_ot`]="{ item }">
          {{!item.numero_ot?'NO RELLENADO':item.numero_ot}}
          </template>
          <template v-slot:[`item.trabajador`]="{ item }">
          {{!item.trabajador?'NO RELLENADO':item.trabajador}}
          </template>
       
          <template v-slot:item.actions="{ item }">
            <dialog-datos-historico tipo_boton="icono" :cabecera="item"></dialog-datos-historico>
          </template>
          <template v-slot:no-results>
                <span>No hay datos para esta búsqueda</span>
            </template>
        </v-data-table>
        <!-- Apartado que se muestra cuando queremos ver un ciclo -->
        <div v-if="seeGraphic && !loadingChart">
        
          <v-row class="float-right">
            <v-btn
            class="float-right"
            fab
            x-small
            >
              <v-icon dark @click="closeGraphic()">
              mdi-close
              </v-icon>
            </v-btn>
          </v-row>
         
        </div>
        </v-card>
      </v-container> 
     
    </v-app>
  </template>
  <script>
import DialogDatosHistorico from "@/components/modulos/DialogDatosHistorico.vue";
import moment from "moment-timezone";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      nada: null,
      sortBy: "id_trabajo",
      sortDesc: true,
      detalles_con_pausas: [],
      datos_pv_1: [],
      datos_pv_2: [],
      datos_agua: [],
      datos_setpoint: [],
      loading: false,
      mensajeError: "",
      tipo_tratamiento: null,
      filtrar: false,
      worker: null,
      horno: null,
      fecha_inicio: null,
      fecha_fin: null,
      fechaInicioInput: false,
      fechaFinInput: false,
      datosDesdeDíaAnterior: [],
      loadingChart: false,
      datos: [],
      
      datosCiclo: {},
      seeGraphic: false,
      headers: [
        { text: "CICLO", align: "center", value: "id_trabajo" },
        { text: "Receta", align: "center", value: "nombre_receta" },
        {
          text: "Tipo de Tratamiento",
          align: "center",
          value: "nombre_tipo_tratamiento",
        },
        { text: "Numero OT", align: "center", value: "numero_ot" },
        { text: "Fecha Inicio", align: "center", value: "fecha_inicio" },
        { text: "Fecha Fin", align: "center", value: "fecha_fin" },
        { text: "Trabajador", align: "center", value: "trabajador" },
        { text: "Acciones",  align: "center", value: "actions", sortable: false },
      ],
    };
  },
  async mounted() {
    const currentDate = new Date();
    console.log("MONTADO!!!!");
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    let year = firstDayOfMonth.getFullYear();
    let month = String(firstDayOfMonth.getMonth() + 1).padStart(2, "0");
    let day = String(firstDayOfMonth.getDate()).padStart(2, "0");
    this.fecha_inicio = `${year}-${month}-${day}`;

    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );
    year = lastDayOfMonth.getFullYear();
    month = String(lastDayOfMonth.getMonth() + 1).padStart(2, "0");
    day = String(lastDayOfMonth.getDate()).padStart(2, "0");
    this.fecha_fin = `${year}-${month}-${day}`;
    const historicos_raw = await this.getHistoricosTrabajos({fecha_inicio: this.fecha_inicio,fecha_fin: this.fecha_fin, tipo_tratamiento:null });
    this.setHistoricos(historicos_raw.data)
  },
  computed: {
    ...mapState([
      "users",
      "tipos_de_tratamiento",
      "historico_trabajos",
      "recetas",
    ]),
     
    
    tratamientos() {
      let tratamientos = JSON.parse(JSON.stringify(this.tipos_de_tratamiento));
      tratamientos.push({ id: null, name: "-" });
      return tratamientos;
    },
    trabajadores() {
      let trabajadores = JSON.parse(JSON.stringify(this.users));
      trabajadores.push({ id: null, username: "-" });
      return trabajadores;
    },
    datosTabla() {
      let array_datos = [];
      console.log(this.historico_trabajos);
      console.log(this.recetas);
      console.log(this.tipos_de_tratamiento.length);
      if (this.filtrar) {
        if(
          this.datos.length > 0 &&
          this.recetas.length > 0 &&
          this.tipos_de_tratamiento.length > 0
        ) {
          this.datos.forEach((historico) => {
            let dato = JSON.parse(JSON.stringify(historico));
            let receta = this.recetas.find(
              (e) => e.id_receta == dato.id_receta
            );
            let trabajador = this.users.find(
              (e) => e.id == dato.id_usuario
            );
            if(dato.fecha_inicio)
              dato.fecha_inicio = this.fecha_formateada(dato.fecha_inicio)
            if(dato.fecha_fin)
              dato.fecha_fin = this.fecha_formateada(dato.fecha_fin)
            if(receta)
              dato.nombre_receta = receta.name;

            dato.trabajador = trabajador.username
            array_datos.push(dato);
          });
        }
      } else {
        if (
          this.historico_trabajos.length > 0 &&
          this.recetas.length > 0 &&
          this.tipos_de_tratamiento.length > 0
        ) {
          this.historico_trabajos.forEach((historico) => {
            let dato = JSON.parse(JSON.stringify(historico));
            let receta = this.recetas.find(
              (e) => e.id_receta == dato.id_receta
            );
            let trabajador = this.users.find(
              (e) => e.id == dato.id_usuario
            );
            if(dato.fecha_inicio)
              dato.fecha_inicio = this.fecha_formateada(dato.fecha_inicio)
            if(dato.fecha_fin)
              dato.fecha_fin = this.fecha_formateada(dato.fecha_fin)
            dato.trabajador = trabajador.username
            if(receta)
              dato.nombre_receta = receta.name;
            array_datos.push(dato);
          });
        }
      }
      return array_datos;
    },
  },
  methods: {
    ...mapActions("api", [
      "getUltimoTratamiento",
      "getHistoricosTrabajos",
      "getTrabajo",

    ]),
    ...mapActions(['setHistoricos']),
    async cargarUltimoTratamiento(){
      let datosTrabajo = await this.getUltimoTratamiento();
      // let datosTrabajo = await this.getUltimoTratamiento()
      this.datosCiclo = datosTrabajo.data;
      if (this.datosCiclo.valores) {
        this.show()
      }
    },
    fecha_formateada(f) {
      return moment(f).format("YYYY-MM-DD HH:mm:ss");
    },
    getCurretDate() {
      return new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
    },
    getDayFromDate(date) {
      return date.split(" ")[0];
    },
    getHourFromDate(date) {
      return date.split("T")[1].substring(0, 8);
    },
    async getDatosHistorico() {
      this.loading = true;
      this.filtrar = true;
      console.log(this.fecha_inicio, this.fecha_fin, this.tipo_tratamiento);
      try {
        console.log( this.fecha_inicio,this.fecha_fin, this.tipo_tratamiento, this.worker);
        let res = await this.getHistoricosTrabajos({
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          tipo_tratamiento: this.tipo_tratamiento,
          usuario: this.worker,
        });
        if (res.data) {
          console.log("HOLAAAAAAAAAAAAAAAAAAAAaaa ", res.data);
          this.mensajeError = "";
          this.datos = res.data;
          this.datos.forEach((historico) => {
            let receta = this.recetas.find(
              (e) => e.id_receta == historico.id_receta
            );
            historico.nombre_receta = receta.name;
          });
        } else this.mensajeError = res.data.message;
      } catch (e) {
        this.mensajeError = `Error ${e}`;
      } finally {
        console.log("LISTOOOOOOOOOOOO");
        this.loading = false;
      }
    },
   
   
    async getDatosHistoricoConFecha(f_inicio, f_fin) {
      this.datosDesdeDíaAnterior = await this.axios.get("/get-ciclos-horno", {
        params: {
          firstDay: f_inicio,
          lastDay: f_fin,
          horno: this.horno,
          // lote_mp: this.lote_mp,
          // worker: this.trabajador
        },
        headers: { token: localStorage.getItem("token") },
      });
      //console.log(this.datosDesdeDíaAnterior)
    },
    //Actualmente sin uso
    // diaAnterior(){
    // const yesterday = new Date()
    // console.log(yesterday)
    // yesterday.setDate(yesterday.getDate() - 1)
    // return this.formatDate(yesterday)
    // },
    diaAnterior2(ano, mes, dia) {
      let mes_menos_uno = parseInt(mes) - 1; //Internamente empieza desde 0
      const yesterday = new Date(ano, mes_menos_uno.toString(), dia);
      //console.log(yesterday)
      yesterday.setDate(yesterday.getDate() - 1);
      return this.formatDate(yesterday);
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    formatDate(date) {
      // yyyy-mm-dd
      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    async actualizarCiclosDesdeDíaAnterior() {
      let ayer = this.diaAnterior2(
        this.fecha_inicio.split("-")[0],
        this.fecha_inicio.split("-")[1],
        this.fecha_inicio.split("-")[2]
      );
      this.ciclosDesdeDiaAnterior = await this.getDatosHistoricoConFecha(
        ayer,
        this.fecha_fin
      );
    },
  }, //FIN methods
  created() {
    // this.getDatosHistorico();
  },
  components: {
    DialogDatosHistorico
  },
};
</script>
  